export const resolveProductPrice = (product = {}) => {
  const originalPrice = Number(product.originalPrice ?? product.price ?? 0)
  const explicitEffective = Number(product.effectivePrice ?? product.priceMeta?.effectivePrice)
  if (Number.isFinite(explicitEffective) && explicitEffective > 0 && explicitEffective < originalPrice) {
    const discountAmount = originalPrice - explicitEffective
    return {
      originalPrice,
      effectivePrice: explicitEffective,
      discountPercent: Math.round((discountAmount / originalPrice) * 100),
      source: product.priceSource || product.priceMeta?.source || 'weekly_deal'
    }
  }

  const weeklyPrice = Number(product.weeklyDeal?.effectivePrice ?? product.weeklyDeal?.dealPrice ?? product.weeklyDealPrice)
  if (product.isWeeklyDeal && Number.isFinite(weeklyPrice) && weeklyPrice > 0 && weeklyPrice < originalPrice) {
    const discountAmount = originalPrice - weeklyPrice
    return {
      originalPrice,
      effectivePrice: weeklyPrice,
      discountPercent: Math.round((discountAmount / originalPrice) * 100),
      source: 'weekly_deal'
    }
  }

  const discount = Number(product.discount || product.priceMeta?.discountPercent || 0)
  if (discount > 0) {
    return {
      originalPrice,
      effectivePrice: originalPrice - Math.floor((originalPrice * discount) / 100),
      discountPercent: discount,
      source: product.priceSource || 'listing_discount'
    }
  }

  return { originalPrice, effectivePrice: originalPrice, discountPercent: 0, source: 'regular' }
}
